import React, { useState } from 'react';
import { Layer, Box, Text, Grid, Button } from 'grommet';
import PrimaryButton from '../PrimaryButton';

interface modalProperties {
  onEsc: () => void;
  onClickOutside: () => void;
  showModal: boolean;
  children: JSX.Element;
}

export default ({
  showModal,
  onEsc,
  onClickOutside,
  children
}: modalProperties) => {
  if (showModal) {
    return (
      <Layer onEsc={onEsc} onClickOutside={onClickOutside}>
        {children}
      </Layer>
    );
  }
  return null;
};
